export default __webpack_public_path__ + "static/media/AMA-Education-System.20f6c5a8.png";